class ComplexProductFeature extends HTMLElement {
  constructor() {
    super();

    this._pinProductWrapper();
  }

  _pinProductWrapper() {
    const productLandingNavigation = document.querySelector(
      "product-landing-navigation"
    );

    const baseOffset = 40;
    const offset = productLandingNavigation
      ? productLandingNavigation.getBoundingClientRect().height + baseOffset
      : baseOffset;

    this.style.setProperty(
      "--product-landing-navigation-offset",
      `${offset}px`
    );
  }
}

if (!customElements.get("complex-product-feature")) {
  customElements.define("complex-product-feature", ComplexProductFeature);
}
